import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c01f88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:hello@jobbuddytech.com" }, "let us know", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:hello@jobbuddytech.com" }, "contacting us", -1))
const _hoisted_7 = { class: "container my-4" }
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = { class: "col-md-8" }
const _hoisted_10 = { class: "card border-0 rounded-4 shadow" }
const _hoisted_11 = { class: "card-body p-4" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label small" }, "Name", -1))
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label small" }, "Email", -1))
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label small" }, "Occupation", -1))
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label small" }, "Gender", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Male", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Female", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label small" }, "Employment Status", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Unemployed - Casually browsing", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Unemployed - Long term unemployed", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Employed - Looking at new companies", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Employed - Looking to change career/role", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Graduate", -1))
const _hoisted_30 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label small" }, "Country", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select your country", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center border-top pt-4 mb-4"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted small" }, "Unsaved changes", -1))
const _hoisted_37 = { class: "card bg-light border-0 rounded-3 mt-4" }
const _hoisted_38 = { class: "card-body text-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-secondary mb-4" }, "Current Plan", -1))
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = { class: "badge text-white bg-success px-4 py-2" }
const _hoisted_43 = {
  key: 0,
  class: "badge bg-warning text-dark ms-2"
}
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1))
const _hoisted_46 = {
  key: 0,
  class: "text-muted mt-2"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock me-2" }, null, -1))
const _hoisted_48 = { class: "d-flex gap-3 justify-content-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-up-circle me-2" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear me-2" }, null, -1))
const _hoisted_51 = { class: "card bg-light border-0 rounded-3 mt-4" }
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-danger mb-3" }, "Danger Zone", -1))
const _hoisted_54 = { class: "d-flex justify-content-center" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash me-1" }, null, -1))
const _hoisted_56 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0, 0, 0, 0.5)"}
}

import { ref, onMounted, computed } from "vue";
import Modal from "@/components/Modal.vue";
import { countries, Country } from "../components/CountriesList";
import { UserApiService } from "@/services/UserApiService";
import { SubscriptionsApiService } from "@/services/SubscriptionsApiService";
import router from "../router";
import { SubscriptionPlan } from "@models/SystemEnums";
import store from "../store";
import { toast } from "vue3-toastify";
import Subscribe from "@/views/Subscribe.vue";
import { useAuth0 } from "@auth0/auth0-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfilePopout',
  setup(__props) {

const { logout } = useAuth0();

const cancelSubscriptionModal = ref();
const deleteAccountModal = ref();
const hasChanges = ref(false);
const showSubscribeModal = ref(false);
const user = ref<{
  name: string;
  email: string;
  occupation: string;
  gender: string;
  employmentStatus: string;
  country: Country | string;
  subscriptionPlan: SubscriptionPlan | null;
  subscriptionStatus: string | null;
  trialEndDate: Date | null;
  hasHadTrial: boolean;
}>({
  name: "",
  email: "",
  occupation: "",
  gender: "",
  employmentStatus: "",
  country: "",
  subscriptionPlan: null,
  subscriptionStatus: null,
  trialEndDate: null,
  hasHadTrial: false,
});

let originalUserData: typeof user.value | null = null;

const isTrialActive = computed(() => {
  return user.value.trialEndDate && new Date(user.value.trialEndDate) > new Date();
});

async function loadUser() {
  try {
    user.value = await store.getters["user/getLoggedInUser"];
    originalUserData = JSON.parse(JSON.stringify(user.value));
  } catch (error) {
    console.error("Failed to load user:", error);
    toast.error("Failed to load user data");
  }
}

function checkChanges() {
  if (!originalUserData) return;
  hasChanges.value = JSON.stringify(originalUserData) !== JSON.stringify(user.value);
}

async function updateUser() {
  try {
    await store.dispatch("user/updateUser", user.value);
    originalUserData = JSON.parse(JSON.stringify(user.value));
    hasChanges.value = false;
    toast.success("Profile updated successfully");
  } catch (error) {
    console.error("Failed to update user:", error);
    toast.error("Failed to update profile");
  }
}

async function cancelSubscription(force = false) {
  if (!force) {
    cancelSubscriptionModal.value.show();
    return;
  }
  const result = await SubscriptionsApiService.cancelSubscription();
  if (result.status == 200) {
    toast.success("Subscription cancelled successfully");
    await store.dispatch("user/loadLoggedInUser");
    user.value = await store.getters["user/getLoggedInUser"];
  } else {
    toast.error("Failed to cancel subscription");
  }
  cancelSubscriptionModal.value.hide();
}

async function deleteUserAccount(force = false) {
  if (!force) {
    deleteAccountModal.value.show();
    return;
  }
  const result = await UserApiService.deleteUser();
  if (result.status == 200) {
    toast.success("Account deleted successfully");
    logout({ returnTo: "https://jobbuddytech.com" });
  } else {
    toast.error("Failed to delete account");
  }
  deleteAccountModal.value.hide();
}

async function openSubscriptionPortal() {
  const portalUrl = process.env.VUE_APP_STRIPE_CUSTOMER_MANAGEMENT_PORTAL;
  if (portalUrl) {
    window.location.href = portalUrl;
  } else {
    console.error("Stripe customer portal URL is not configured.");
    toast.error("Could not open subscription management portal.");
  }
}

const formatPlanName = (plan: string) => {
  return plan
    .split(/(?=[A-Z])/)
    .join(" ")
    .toUpperCase();
};

const getPlanDescription = computed(() => {
  switch (user.value.subscriptionPlan) {
    case SubscriptionPlan.BASIC:
      return "Create up to 3 job applications | 10 responses per month | Access to Basic Models";
    case SubscriptionPlan.SILVER:
      return "Create up to 125 applications | Unlimited responses per month | Priority Support | Most Advanced AI";
    case SubscriptionPlan.JOB_SEEKER:
      return "Create up to 75 applications | 75 responses per month | Priority Support | Most Advanced AI";
    case SubscriptionPlan.GOLD:
      return "Create unlimited applications | Unlimited responses per month | Priority Support | Most Advanced AI";
    case SubscriptionPlan.BUSINESS:
      return "Create up to 300 applications | 300 responses per month | 24/7 Priority Support | Advanced Business Tools";
    default:
      return "Create up to 3 job applications | 5 responses per month | Access to Basic Models";
  }
});

const formatDate = (date: Date | null) => {
  if (!date) return "N/A"; // Return a placeholder if date is null
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

onMounted(() => {
  loadUser();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Modal, {
      title: "Are you sure you want to cancel your subscription?",
      ref_key: "cancelSubscriptionModal",
      ref: cancelSubscriptionModal
    }, {
      body: _withCtx(() => [
        _createTextVNode(" Sorry to hear you're cancelling your subscription! If there's anything JobBuddy could do keep you as a customer, why not "),
        _hoisted_1,
        _createTextVNode(". We always strive to improve, and we'd love to hear your feedback. "),
        _hoisted_2,
        _hoisted_3,
        _createTextVNode(" Please note, cancelling your subscription will take immediate effect and you will lose all premium benefits. ")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelSubscription(true))),
          class: "btn btn-danger"
        }, "Cancel")
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      title: "Are you sure you want to delete your account?",
      ref_key: "deleteAccountModal",
      ref: deleteAccountModal
    }, {
      body: _withCtx(() => [
        _createTextVNode(" This action cannot be undone. All your data will be permanently deleted from our systems. "),
        _hoisted_4,
        _hoisted_5,
        _createTextVNode(" If you're experiencing issues with the service, please consider "),
        _hoisted_6,
        _createTextVNode(" before deleting your account. ")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteUserAccount(true))),
          class: "btn btn-danger"
        }, "Delete Account")
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.name) = $event)),
                  onInput: checkChanges
                }, null, 544), [
                  [_vModelText, user.value.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.email) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, user.value.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.occupation) = $event)),
                  onInput: checkChanges
                }, null, 544), [
                  [_vModelText, user.value.occupation]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.gender) = $event)),
                  class: "form-select",
                  onChange: checkChanges
                }, _hoisted_22, 544), [
                  [_vModelSelect, user.value.gender]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.value.employmentStatus) = $event)),
                  class: "form-select",
                  onChange: checkChanges
                }, _hoisted_30, 544), [
                  [_vModelSelect, user.value.employmentStatus]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((user.value.country) = $event)),
                  class: "form-select",
                  onChange: checkChanges
                }, [
                  _hoisted_33,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: country.code,
                      value: country.name
                    }, _toDisplayString(country.name), 9, _hoisted_34))
                  }), 128))
                ], 544), [
                  [_vModelSelect, user.value.country]
                ])
              ]),
              (hasChanges.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: updateUser
                    }, "Save Changes")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("h5", _hoisted_41, [
                      _createElementVNode("span", _hoisted_42, _toDisplayString(formatPlanName(user.value.subscriptionPlan ?? _unref(SubscriptionPlan).BASIC)), 1),
                      (isTrialActive.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, " Trial "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createTextVNode(" " + _toDisplayString(getPlanDescription.value), 1)
                    ]),
                    (isTrialActive.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _hoisted_47,
                          _createTextVNode(" Trial ends on " + _toDisplayString(formatDate(user.value.trialEndDate)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    (user.value.subscriptionPlan !== _unref(SubscriptionPlan).GOLD)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-primary",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (showSubscribeModal.value = true))
                        }, [
                          _hoisted_49,
                          _createTextVNode(" Upgrade Plan ")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (openSubscriptionPortal()))
                    }, [
                      _hoisted_50,
                      _createTextVNode(" Manage Subscription ")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-danger",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (deleteUserAccount()))
                    }, [
                      _hoisted_55,
                      _createTextVNode(" Delete My Account ")
                    ])
                  ])
                ])
              ]),
              (showSubscribeModal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createVNode(Subscribe, {
                      "is-modal": true,
                      onClose: _cache[11] || (_cache[11] = ($event: any) => (showSubscribeModal.value = false))
                    }),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close position-absolute top-0 end-0 m-4",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (showSubscribeModal.value = false)),
                      style: {"z-index":"1050"}
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})